import React, { useState } from "react";
import Navbar from "../common/navbar";
import { Container, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import authService from "../../services/authService";

const Signup = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    emailValid: false,
    showPassword: false,
    showConfirmPassword: false,
  });
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "email") {
      validateEmail(value);
    }
  };

  const validateEmail = (email) => {
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setFormData((prevState) => ({ ...prevState, emailValid }));
  };

  const validatePassword = (password) => {
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasMinLength = password.length >= 8;
    return hasLowercase && hasUppercase && hasNumber && hasMinLength;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!showPasswordFields) {
      setShowPasswordFields(true);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!validatePassword(formData.password)) {
      setError(
        "Password must be 8 characters, including 1 uppercase, 1 lowercase & 1 number"
      );
      return;
    }

    setLoading(true);
    try {
      await authService.register(formData.email, formData.password);
      navigate("/login", {
        state: {
          successMessage: "Account created successfully. You can now log in",
        },
      });
    } catch (error) {
      console.error(
        "Registration Error:",
        error.response?.data || error.message
      );
      setError(
        error.response?.data?.message ||
          "Registration failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setFormData((prevState) => ({
      ...prevState,
      showPassword: !prevState.showPassword,
    }));
  };

  const toggleConfirmPasswordVisibility = () => {
    setFormData((prevState) => ({
      ...prevState,
      showConfirmPassword: !prevState.showConfirmPassword,
    }));
  };

  const handleGoBack = () => {
    setFormData({
      email: "",
      password: "",
      confirmPassword: "",
      emailValid: false,
      showPassword: false,
      showConfirmPassword: false,
    });
    setShowPasswordFields(false);
    setError("");
  };

  return (
    <div className="body-font">
      <Navbar hideNavLinks={true} />
      <Container className="text-center empty-space-mt w-lg-25">
        <h1 className="text-nowrap fs-five-title my-4 d-flex justify-content-center align-items-center">
          Create an{" "}
          <div className="mx-1 purple-color mb-0 fs-5 righteousy-font">
            <span className="fs-3">Nouraa</span>
            <span className="fs-two">.ai</span>
          </div>{" "}
          Account
        </h1>
        <small className="gray-color d-block text-center my-3">
          Start your 25 minutes free trial.
        </small>
        <p className="gray-color">
          Already have an account?{" "}
          <Link
            className="purple-color text-decoration-none fw-bold"
            to="/login"
          >
            Log in
          </Link>
        </p>
        <form onSubmit={handleSubmit} className="login-form my-4">
          <div className="form-group mb-4">
            <label className="text-start w-100 w-md-50 w-lg-25 mb-1 fw-bold gray-color">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              placeholder="Enter your email"
              onChange={handleInputChange}
              className="form-control w-100 w-md-50 w-lg-25 mx-auto"
              required
            />
            {!formData.emailValid && formData.email && (
              <small className="text-danger d-block text-start mt-1">
                Invalid email address
              </small>
            )}
          </div>
          {showPasswordFields && (
            <>
              <div className="form-group mb-1 position-relative">
                <label className="text-start w-100 w-md-50 w-lg-25 mb-1 fw-bold gray-color">
                  Password
                </label>
                <input
                  type={formData.showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  placeholder="Enter your password"
                  onChange={handleInputChange}
                  className="form-control w-100 w-md-50 w-lg-25 mx-auto"
                  required
                />
                {formData.password && (
                  <span
                    onClick={togglePasswordVisibility}
                    className="position-absolute top-50 end-0 me-3"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={
                        formData.showPassword
                          ? "/assets/eye-slash.svg"
                          : "/assets/eye.svg"
                      }
                      alt="Toggle visibility"
                    />
                  </span>
                )}
              </div>
              <small className="gray-color d-block text-start mt-1 mb-4">
                Must be at least 8 characters, 1 uppercase, 1 lowercase & 1
                number
              </small>
              <div className="form-group mb-1 position-relative">
                <label className="text-start w-100 w-md-50 w-lg-25 mb-1 fw-bold gray-color">
                  Confirm Password
                </label>
                <input
                  type={formData.showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  placeholder="Confirm your password"
                  onChange={handleInputChange}
                  className="form-control w-100 w-md-50 w-lg-25 mx-auto"
                  required
                />
                {formData.confirmPassword && (
                  <span
                    onClick={toggleConfirmPasswordVisibility}
                    className="position-absolute top-50 end-0 me-3"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={
                        formData.showConfirmPassword
                          ? "/assets/eye-slash.svg"
                          : "/assets/eye.svg"
                      }
                      alt="Toggle visibility"
                    />
                  </span>
                )}
              </div>
              <small className="gray-color d-block text-start mt-1 mb-4">
                Make sure both the password match
              </small>
              {error && (
                <p className="mb-4 text-danger text-start w-100 w-md-50 w-lg-25 mx-auto">
                  {error}
                </p>
              )}
            </>
          )}
          <Button
            className="btn-primary-style fs-one fw-bold w-100 w-md-50 w-lg-25"
            type="submit"
            disabled={!formData.emailValid || loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : showPasswordFields ? (
              "Sign Up"
            ) : (
              "Continue"
            )}
          </Button>
          {showPasswordFields && (
            <button
              onClick={handleGoBack}
              className="purple-color text-decoration-none fw-bold btn btn-link mt-3"
            >
              Go Back
            </button>
          )}
        </form>
        {!showPasswordFields && (
          <div className="or-login-container">
            <div className="d-flex align-items-center my-4 w-100 w-md-50 w-lg-25 mx-auto">
              <hr className="flex-grow-1" />
              <span className="mx-2 gray-color">OR</span>
              <hr className="flex-grow-1" />
            </div>
            <div className="d-flex flex-column align-items-center">
              <Button className="btn-google w-100 w-md-50 w-lg-25 mb-2 bg-white black-color fw-bold border-secondary-subtle">
                <img
                  src="/assets/Social icon.svg"
                  alt="Google"
                  className="me-2"
                />
                Continue with Google
              </Button>
              <Button className="btn-facebook w-100 w-md-50 w-lg-25 mb-2 bg-white black-color fw-bold border-secondary-subtle">
                <img
                  src="/assets/Social-icon1.svg"
                  alt="Facebook"
                  className="me-2"
                />
                Continue with Facebook
              </Button>
              <Button className="btn-apple w-100 w-md-50 w-lg-25 bg-white black-color fw-bold border-secondary-subtle">
                <img
                  src="/assets/Social-icon2.svg"
                  alt="Apple"
                  className="me-2"
                />
                Continue with Apple
              </Button>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default Signup;
